var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { colors } from "../../../base/styled/variables.styled";
import { typography } from "../../../base/styled/typography.style";
export const ContentWrapper = styled.span `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  position: relative;
`;
export const TextWrapper = styled.span.withConfig({
    shouldForwardProp: (prop) => !['underline'].includes(prop),
}) `
  text-decoration: inherit;
  display: flex;
  align-items: center;
  text-align: center;
  ${({ underline }) => underline && css `text-decoration: underline;`}
`;
// Componente SVG completo com attrs
export const ArrowIcon = styled.svg.attrs(() => ({
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    children: (_jsx("path", { d: "M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" }))
})) `
  width: 16px;
  height: 16px;
  color: inherit;
  vertical-align: -0.125em;
  transition: all 0.3s ease;
`;
const getTypographyStyles = (size, underline) => {
    let baseTypo;
    if (size === 'large') {
        baseTypo = underline ? typography.linkLargeUnderlined : typography.linkLarge;
    }
    else {
        baseTypo = underline ? typography.linkSmallUnderlined : typography.linkSmall;
    }
    const { color: _color, textDecoration: _textDecoration } = baseTypo, restStyles = __rest(baseTypo, ["color", "textDecoration"]);
    return css `
        font-family: ${restStyles.fontFamily};
        font-weight: ${restStyles.fontWeight};
        font-size: ${restStyles.fontSize};
        line-height: ${restStyles.lineHeight};

        ${Object.entries(restStyles).map(([key, value]) => {
        if (key.startsWith('@media')) {
            return css `
          ${key} {
              ${Object.entries(value).map(([mediaKey, mediaValue]) => css `${mediaKey}: ${mediaValue};`)}
          }
      `;
        }
        return null;
    })}
    `;
};
export const StyledLink = styled.a.withConfig({
    shouldForwardProp: (prop) => !['inverse', 'size', 'underline', 'disabled'].includes(prop)
}) `
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  padding: 0px 4px;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;

  ${ContentWrapper} {
    ${({ size, underline }) => getTypographyStyles(size, underline)}

    i {
      font-size: 16px;
      width: 16px;
      height: 16px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      color: inherit;
      font-style: normal;
      vertical-align: -0.125em;
    }

    ${ArrowIcon} {
      width: 16px;
      height: 16px;
      color: inherit;
    }
  }

  color: ${({ inverse, disabled }) => {
    if (disabled)
        return colors.neutral400;
    return inverse ? colors.umbuGreen300 : colors.brand500;
}};

  &:hover {
    color: ${({ inverse, disabled }) => {
    if (disabled)
        return colors.neutral400;
    return inverse ? colors.softLinen : colors.brand300;
}};
  }

  &:focus {
    outline: none;
  }

  &:focus ${ContentWrapper} {
    &::after {
      content: '';
      position: absolute;
      top: -4px;
      bottom: -4px;
      left: -4px;
      right: -4px;
      border-radius: 4px;
      //border: 3px solid ${({ inverse }) => inverse ? colors.brand200 : colors.brand300};
      pointer-events: none;
    }
  }

  &:visited {
    color: ${({ inverse }) => inverse ? colors.deepPurpleInverse : colors.deepPurple};
  }

  ${({ disabled }) => disabled && css `
    cursor: not-allowed;
    color: ${colors.neutral400};
  `}
`;
//# sourceMappingURL=Link.style.js.map